import type {
  AdminTeamsResponse,
  AdminTeamsUpdateRequest,
  AdminTeamsUpdateSuccess,
  ApiError,
  DrawResponse,
  EntryCreateRequest,
  EntryCreateSuccess,
  LeaderboardsResponse,
} from "@shared/types";

async function unwrap<T>(res: Response): Promise<T> {
  const contentType = res.headers.get("content-type") ?? "";
  const isJson = contentType.includes("application/json");
  const body = isJson ? await res.json().catch(() => null) : null;
  if (!res.ok) {
    const err = (body ?? {}) as ApiError;
    throw Object.assign(new Error(err.message ?? err.error ?? `HTTP ${res.status}`), {
      status: res.status,
      apiError: err,
    });
  }
  if (body === null) {
    throw new Error(`Expected JSON from ${res.url} but got ${contentType || "no content-type"}`);
  }
  return body as T;
}

function compQuery(comp?: number): string {
  return comp === 2 ? "?comp=2" : "";
}

export const api = {
  leaderboards: (comp?: number) =>
    fetch(`/api/leaderboards${compQuery(comp)}`).then(unwrap<LeaderboardsResponse>),
  draw: (comp?: number) =>
    fetch(`/api/draw${compQuery(comp)}`, { method: "POST" }).then(unwrap<DrawResponse>),
  createEntry: (body: EntryCreateRequest, comp?: number) =>
    fetch(`/api/entries${compQuery(comp)}`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
    }).then(unwrap<EntryCreateSuccess>),
  adminTeams: () => fetch("/api/admin/teams").then(unwrap<AdminTeamsResponse>),
  saveTeams: (body: AdminTeamsUpdateRequest) =>
    fetch("/api/admin/teams", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
    }).then(unwrap<AdminTeamsUpdateSuccess>),
};
